import { defineStore } from 'pinia'

export const useHomeStore = defineStore('home', {
  state: () => (
    {
      params: {},
    }),
  getters: {
  },
  actions: {
    setParams(params) {
      this.params = params;
    },
    setParam(name, value) {
      this.params[name] = value;
    },
    deleteParam(name) {
      delete this.params[name];
    },
    deleteAllParams() {
      this.params = {};
    }
  },
});
